// extracted by mini-css-extract-plugin
export default {"toRightSide":"navbarStyle_toRightSide__ZjB1f","buttonColor":"navbarStyle_buttonColor__6nF3w"};